namespace Matrix.Workflow {
    export interface ClientFunctionGetModelResponse extends Serenity.ServiceResponse {
        TriggerCode?: string;
        FunctionName?: string;
        ActionVerb?: string;
        Description?: string;
        Title?: string;
        Parameters?: Serenity.PropertyItem[];
    }
}
